import React, { Component } from 'react';
import ModalStep from "../modalStep/index";
import Project from "./project";
import Plan from "./plan";

import {observer,inject} from 'mobx-react';

import Grid from 'material-ui/Grid';
import Tabs, { Tab } from 'material-ui/Tabs';
import Button from 'material-ui/Button';
import {withStyles} from "material-ui/styles/index";
import {changeProject} from "../../constants/theme";

const styles = theme => ({
    tabHeader: {
        fontFamily: 'DB Heavent',
        fontSize: '2rem',
        letterSpacing: '0.1rem'
    }
});

@inject("projectDataStore")
@observer
class Wizard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: true,
            value: 0
        };
    }

    componentDidMount(){
        this.props.projectDataStore.resetWizard();
        this.props.projectDataStore.getProject();
        const { subType, listSubType } = this.props.projectDataStore;
        listSubType.map((value,index) => {
            if(subType === value) {
                this.setState({value: index});
                return true;
            }
        });
    }

    handleChange = (event, value) => {
        this.setState({ value });
        this.props.projectDataStore.setSubType(this.props.projectDataStore.listSubType[value]);
    };

    changeProject() {
        this.props.projectDataStore.setType('project');
        this.props.history.push("/wizard");
    }

    render() {
        const { value, isOpen } = this.state;
        const { history,classes } = this.props;
        const { type, listSubType, projectDataSelected } = this.props.projectDataStore;

        return (
            <div className="wizard">
                <ModalStep show={isOpen}
                            history={history}>
                    <div className='contentHeader'>
                        { type === 'project' ?
                            <Tabs value={value}
                                  onChange={this.handleChange}
                                  indicatorColor="#25bdae"
                                  scrollable
                                  fullWidth >
                                {
                                    listSubType.map((value,index) => {
                                        return( <Tab label={value}
                                                     key={index}
                                                     classes={{
                                                         label: classes.tabHeader
                                                     }}
                                        /> )
                                    })
                                }
                            </Tabs>
                            :
                            <div className='displayProject'>
                                <Grid container spacing={0}>
                                    <Grid item xs={9} sm={9} md={10} >
                                        <Grid container spacing={0}>
                                            <Grid item xs={7} sm={3} md={2} style={{textAlign:'center'}}>
                                                <img src={projectDataSelected.logoUrl} alt=''/>
                                            </Grid>
                                            <Grid item xs={3} sm={1} md={1}></Grid>
                                            <Grid item xs={12} sm={7} md={8} >
                                                <span className='nameProject'>{projectDataSelected.title}</span>
                                                <br/>
                                                <span className='nameSite'>{projectDataSelected.site}</span>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={3} sm={3} md={2} style={{textAlign:'right'}}>
                                        <Button fullWidth style={changeProject} onClick={() => this.changeProject()}>เปลี่ยน</Button>
                                    </Grid>
                                </Grid>
                            </div>
                        }
                    </div>
                    <div className='content'>
                        { type === 'project' && <Project key={'project'} value={value} /> }
                        { type === 'plan' && <Plan /> }
                    </div>
                </ModalStep>
            </div>
        );
    }
}

export default withStyles(styles)(Wizard);


// WEBPACK FOOTER //
// ./src/components/wizard/index.js